import { calcTokenBPriceOfTokenA, } from '@cronos-app/swap-sdk';
import { Fraction } from 'bi-fraction';
import { SMART_ROUTER_ENDPOINT_BY_CHAIN } from '../configs/api';
import { ChainId_Internal } from '../types';
export const smartRouterFetcher = async (chainId, clientId, opts) => {
    const raw = await rawFetcher(chainId, clientId, {
        currencyIn: opts.from.address,
        currencyOut: opts.to.address,
        amount: opts.amount,
        maxHops: opts.maxHops,
        maxSplits: opts.maxSplits,
        poolTypes: opts.poolTypes,
        decimals: opts.from.decimals,
    });
    return pipeRaw(raw, opts);
};
const pipeRaw = (raw, opts) => {
    if (!raw)
        return undefined;
    const res = {
        amountIn: {
            ...opts.from,
            amount: raw.amountIn.rawAmount,
        },
        amountOut: {
            ...opts.to,
            amount: raw.amountOut.rawAmount,
        },
        gasEstimate: raw.gasEstimate,
        routes: raw.routes.map((r) => {
            const pool = r.pool.map((p) => {
                let price = new Fraction(1);
                if (p.reserve0 && p.reserve1) {
                    // v2
                    price = calcTokenBPriceOfTokenA(p.token0, p.token1, {
                        token0: p.reserve0.token.address,
                        reserve0: p.reserve0.rawAmount,
                        reserve1: p.reserve1.rawAmount,
                    });
                }
                else if (p.sqrtRatioX96) {
                    // v3
                    // sqrt(reserve0 / reserve1) << 96
                    price = new Fraction(p.sqrtRatioX96)
                        .mul(p.sqrtRatioX96)
                        .div(1n << 192n);
                    // r0 / t0 / (r1 / t1) = r0 / r1 * t1 / t0 = price * 10 ** diff
                    const diff = p.token0.decimals - p.token1.decimals;
                    if (diff !== 0)
                        price = diff > 0 ? price.shl(diff) : price.shr(-diff);
                }
                return {
                    tokenIn: p.token0,
                    tokenOut: p.token1,
                    address: p.address,
                    version: p.version,
                    price: price.toFixed(20), // precision 10 ^ -20 to ensure accuracy
                };
            });
            let input = r.amountIn.token;
            for (const p of pool) {
                // important!
                // pool[0].tokenIn === amountIn && pool[x].tokenIn === pool[x - 1].tokenOut
                if (p.tokenOut.address.toLowerCase() === input.address.toLowerCase()) {
                    p.price = new Fraction(1).div(p.price).toFixed(20);
                    const originOut = {
                        ...p.tokenOut,
                    };
                    p.tokenOut = {
                        ...p.tokenIn,
                    };
                    p.tokenIn = originOut;
                }
                input = p.tokenOut;
            }
            return {
                amountIn: {
                    ...r.amountIn.token,
                    amount: r.amountIn.rawAmount,
                },
                amountOut: {
                    ...r.amountOut.token,
                    amount: r.amountOut.rawAmount,
                },
                gasEstimate: r.gasEstimate,
                percentage: r.percentage / 100,
                pool,
            };
        }),
    };
    return res;
};
const rawFetcher = async (chainId, clientId = '', opts) => {
    const endpoint = SMART_ROUTER_ENDPOINT_BY_CHAIN[chainId];
    const res = (await (await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-client-id': clientId,
        },
        body: JSON.stringify({
            chain: chainId === ChainId_Internal.CRONOS_EVM_MAINNET ||
                chainId === ChainId_Internal.CRONOS_EVM_TESTNET
                ? 'CRONOS'
                : chainId === ChainId_Internal.ZK_EVM ||
                    chainId === ChainId_Internal.ZK_EVM_TEST
                    ? 'CRONOSZK'
                    : 'ETHEREUM',
            tradeType: 'EXACT_INPUT',
            currencyIn: opts.currencyIn.toLowerCase(),
            currencyOut: opts.currencyOut.toLowerCase(),
            amount: new Fraction(opts.amount)
                .shr(opts.decimals)
                .toFixed(opts.decimals),
            maxHops: opts.maxHops,
            maxSplit: opts.maxSplits,
            poolTypes: opts.poolTypes,
        }),
    })).json()).data;
    return res;
};
